import { Directive, ElementRef, OnInit } from '@angular/core';
const MENU_COLOR_RGB = ['116', '160', '203'];

@Directive({
  selector: '[enaukaColorFade]'
})
export class ColorFadeDirective implements OnInit {
  private menuElement;
  private menuHeight;

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.init(this.elementRef.nativeElement);
  }

  private init(selector) {
    this.initElements(selector);
    this.bindEvents();
    this.setMenuOpacity();
  }

  private initElements(selector) {
    this.menuElement = $(selector);
    this.menuHeight = this.menuElement.outerHeight();
  }

  private bindEvents() {
    $(window).on('scroll', () => this.setMenuOpacity());
  }

  private setMenuOpacity() {
    const scroll = $(window).scrollTop();
    let opacity = scroll / this.menuHeight / 2;
    if (opacity > 1)
      opacity = 1;
    this.menuElement.css('background-color', this.setMenuColor(opacity));
  }

  private setMenuColor(opacity) {
    return 'rgba('
      + MENU_COLOR_RGB[0] + ','
      + MENU_COLOR_RGB[1] + ','
      + MENU_COLOR_RGB[2] + ','
      + opacity + ')';
  }

}
